export default __webpack_public_path__ + "static/media/trisuli.f0b1ae9b.jpeg";